import React from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import { useAuth } from "../../auth/AuthContext";
import LicensedTutorialGate from "../tutorial/LicensedTutorialGate";
import "./Ajuda.css";

const Ajuda = () => {
  const [menuClose, setMenuClose] = React.useState(false);
  const [suggestion, setSuggestion] = React.useState("");
  const [sending, setSending] = React.useState(false);
  const [tutorialOpen, setTutorialOpen] = React.useState(false);
  const [feedback, setFeedback] = React.useState({ type: "", message: "" });

  const { user } = useAuth();

  const licensedName = String(user?.full_name || "Licenciado").trim();
  const licensedEmail = String(user?.email || "").trim();

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  const onSubmitSuggestion = async (event) => {
    event.preventDefault();

    const suggestionTrimmed = String(suggestion || "").trim();

    if (suggestionTrimmed.length < 10) {
      setFeedback({
        type: "error",
        message: "Descreva sua sugestao com pelo menos 10 caracteres.",
      });
      return;
    }

    setSending(true);
    setFeedback({ type: "", message: "" });

    try {
      const { data } = await Api.post("/suggestions", {
        subject: "",
        suggestion: suggestionTrimmed,
      });

      if (!data?.ok) {
        throw new Error(data?.message || "Nao foi possivel enviar sua sugestao.");
      }

      setSuggestion("");
      setFeedback({
        type: "success",
        message:
          data?.message ||
          "Sugestao enviada com sucesso. Nossa equipe especializada vai analisar.",
      });
    } catch (err) {
      setFeedback({
        type: "error",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Nao foi possivel enviar sua sugestao no momento.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="app-container">
      <Sidebar close={menuClose} ajudaActive="active" />

      <main className="main-content">
        <Topbar page="Ajuda / Suporte" onToggleMenu={toggleMenu} />

        <section className="card">
          <div className="card-title">Como podemos ajudar?</div>

          <div className="support-text">
            Se voce tiver qualquer duvida sobre comissoes, extrato, saques ou dados bancarios,
            nossa equipe esta pronta para te ajudar.
          </div>
          <div className="support-text">
            Para assuntos financeiros (pagamentos, prazos, saques, ajustes etc.), entre em contato pelo e-mail:
          </div>

          <div className="support-email">financeiro@smartolfativos.com.br</div>

          <div className="support-text">
            Caso prefira um atendimento mais rapido, voce pode falar diretamente conosco via WhatsApp.
          </div>

          <div className="button-row">
            <a
              className="whatsapp-btn"
              href="https://wa.me/5511996513988"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp Suporte
            </a>

            <button
              type="button"
              className="secondary-btn"
              onClick={() => setTutorialOpen(true)}
            >
              Assistir tutorial novamente
            </button>

            <button type="button" className="primary-btn" disabled>
              FAQ (em breve)
            </button>
          </div>

          <div className="suggestion-card">
            <div className="suggestion-title">Enviar sugestao para melhorias</div>
            <div className="support-text suggestion-subtitle">
              Sua sugestao sera enviada para o time de marketing e para a equipe especializada.
            </div>

            <form className="suggestion-form" onSubmit={onSubmitSuggestion}>
              <input type="hidden" name="licensed_name" value={licensedName} />
              <input type="hidden" name="licensed_email" value={licensedEmail} />
              <input type="hidden" name="subject" value="" />

              <label className="suggestion-field suggestion-only-field">
                <span>Sugestao</span>
                <textarea
                  value={suggestion}
                  onChange={(e) => setSuggestion(e.target.value)}
                  placeholder="Descreva sua sugestao"
                  rows={6}
                  maxLength={3000}
                  required
                />
              </label>

              {feedback.message ? (
                <div className={`suggestion-feedback ${feedback.type}`}>{feedback.message}</div>
              ) : null}

              <div className="suggestion-actions compact">
                <button type="submit" className="primary-btn" disabled={sending || !licensedEmail}>
                  {sending ? "Enviando..." : "Enviar sugestao"}
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>

      <LicensedTutorialGate
        user={user}
        forceOpen={tutorialOpen}
        allowClose
        onRequestClose={() => setTutorialOpen(false)}
      />
    </div>
  );
};

export default Ajuda;

